export default "__VITE_ASSET__Cnv731nw__"